import { useNavigate } from "react-router-dom";

const InsightsCard = ({ title, value, change, link, gradient }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(link); // Navigate to the detailed page
  };

  return (
    <div
      className={`p-4 md:p-3 lg:p-4 rounded-md shadow-md cursor-pointer hover:shadow-lg transform hover:scale-105 transition-all duration-300 ${gradient}`}
      onClick={handleClick}
    >
      <h2 className="text-base md:text-sm lg:text-base font-semibold tracking-wide text-white">
        {title}
      </h2>
      <p className="text-3xl md:text-2xl lg:text-3xl font-extrabold mt-2 text-white">
        {value}
      </p>
      <p className="text-xs md:text-xs lg:text-sm font-medium mt-1 text-white opacity-90">
        {change}
      </p>
    </div>
  );
};

const Insights = () => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 lg:gap-8 mt-4 md:mt-6 lg:mt-8 px-2 md:px-4 lg:px-6">
      <InsightsCard
        title="Today's Job Applications"
        value="4,006"
        change="+10.00% (30 days)"
        link="/applications/today"
        gradient="bg-gradient-to-br from-red-400 to-pink-500"
      />
      <InsightsCard
        title="Total Job Applications"
        value="61,344"
        change="+22.00% (30 days)"
        link="/applications/total"
        gradient="bg-gradient-to-br from-green-400 to-teal-500"
      />
      <InsightsCard
        title="Total Interviews Conducted"
        value="34,040"
        change="+2.00% (30 days)"
        link="/interviews/total"
        gradient="bg-gradient-to-br from-blue-400 to-indigo-500"
      />
      <InsightsCard
        title="Total Employers Engaged"
        value="47,033"
        change="+0.22% (30 days)"
        link="/employers/engaged"
        gradient="bg-gradient-to-br from-yellow-400 to-orange-500"
      />
    </div>
  );
};

export default Insights;
